import api from '@/logic/api'

export default {
  getMyTeams: () => api.get('/quiz-teams/mine'),
  getTeam: (id) => api.get(`/quiz-teams/${id}`),
  addMember: (teamId, userId) => api.post(`/quiz-teams/${teamId}/members`, { user_id: userId }),
  checkTeamName: (teamName) => api.get(`/quiz-teams/checkQuizTeamName?name=${encodeURIComponent(teamName)}`),
  createTeam: (teamName) => api.post('/quiz-teams', { name: teamName }),
}
